<template>
  <div class="index" :style="{ 'paddingTop': statusBar + 'rem' }">
    <Header :title="topicName" :back="true" left="首页" />
    <div class="windowmain">
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="previewFile()">文件预览</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="scanQR()">扫描二维码</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="getLocation('1', false)">定位（国标）</button>
        <button class="btn2" color="#2A7EFC" @click="getLocation('2', true)">定位（百度）</button>
        <button class="btn2" color="#2A7EFC" @click="getLocation('3', true)">定位（全球定位系统）</button>

      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="getImage(10, '1', '0', '1')">获取10张图片(相册)</button>
        <button class="btn2" color="#2A7EFC" @click="getImage('6', '0', '2', '1')">获取图片(用户选择)</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="getImage(2, '2', '1', '1')">获取图片(前置摄像头)</button>
        <button class="btn2" color="#2A7EFC" @click="getImage(3, '2', '1', '2')">获取图片(后置摄像头)</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="getFileContent('pdf', -1, -1, 1)">获取文件内容(pdf)</button>
        <button class="btn2" color="#2A7EFC" @click="getFileContent('pdf;jpg;png', 1, 2, 0)">获取文件内容(不限制)</button>
      </div>
      <div class="btn">

        <button class="btn2" color="#2A7EFC" @click="SM4SymEnDecrypt()">SM4加解密</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="launchApp()">唤醒第三方应用</button>
        <button class="btn2" color="#2A7EFC" @click="openPaymentApp()">原生支付</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="signatureData()">加签（推荐）</button>
        <button class="btn1" color="green" @click="signData()">加签（不推荐）</button>
      </div>
      <div class="btn">
        <button class="btn2" color="#2A7EFC" @click="joinMeeting()">视频会议</button>
        <button class="btn2" color="#2A7EFC" @click="getDeviceInfo()">获取设备信息</button>
      </div>
      <div class="btn">
        <input type="file" name="" id="">
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { Field, Button, Form, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      certTest: "",
      statusBar: 0,
      topicName: "原生接口单元测试",

    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
  },

  methods: {
    previewFile() {
      this.$nativeApi.previewFile(
        'https://updatetest.singlewindow.cn/pubnotices/20221229/20221229dec001.pdf', 'pdf', '测试文档'
      ).then((data) => {
        console.log(data);
      });
    },
    scanQR() {
      this.$nativeApi.scanQR().then((data) => {
        console.log(data);
      });
    },
    getLocation(mode, altiude) {
      this.$nativeApi.getLocation(
        mode, altiude
      ).then((data) => {
        console.log(data);
      });
    },
    getImage(count, sourceType, compressLeval, camera, type) {
      this.$nativeApi.getImage(count, sourceType, compressLeval, camera, type).then((data) => {
        console.log(data);
      });
    },
    getFileContent(fileType, fileSize, fileCount, hasContent) {
      this.$nativeApi.getFileContent(fileType, fileSize, fileCount, hasContent).then((data) => {
        console.log(data);
      });
    },
    SM4SymEnDecrypt() {
      this.$nativeApi.SM4SymEnDecrypt(
        0, 0, '加密数据', '07jVbaQsoHi8G1zq', ''
      ).then((data) => {
        console.log(data);
      });
    },
    launchApp() {
      var object = {
        url: 'http://www.customs.gov.cn/customs/302249/302266/index.html'
      }
      this.$nativeApi.launchApp('web', object).then((data) => {
        console.log(data);
      });
    },
    openPaymentApp() {
      var object = {
        scheme: 'alipays://platformapi/startapp?appid=1000007&sourceid=unionpaytax&actionType=route&codeContent=hg123345215412&biz_return_url=asinglewindow://paySuccess'
      }
      this.$nativeApi.openPaymentApp('1', object).then((data) => {
        console.log(data);
      });
    },
    signatureData() {
      this.$nativeApi.signatureData('加签值').then((data) => {
        console.log(data);
      });
    },
    signData() {
      this.$nativeApi.signData('加签值').then((data) => {
        console.log(data);
      });
    },
    joinMeeting() {
      console.log('视频会议')
      this.$nativeApi.joinMeeting('9083706127', '725853', '张三', true, true).then((data) => {
        console.log(data);
      });
    },
    getDeviceInfo() {
      console.log('设备信息')
      this.$nativeApi.getDeviceInfo().then((data) => {
        console.log(typeof data);
        console.log(data);
      });
    }

  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
};
</script>

<style>
</style>